import moment from 'moment'

export default {
  getCompanyIndustries (company) {
    let industries = []
    if (company.industry1) {
      industries.push(company.industry1.name)
    }
    if (company.industry2) {
      industries.push(company.industry2.name)
    }
    return industries.join(', ')
  },
  getMembershipPaymentStatus (membership) {
    if (membership.membership_recurring_status === 'not_required') {
      return false
    }
    if (!membership.payment) {
      return false
    }

    if (membership.payment.payment_status === 1) {
      return 'Complete'
    } else {
      return 'Incomplete'
    }
  },
  getBusinessIndustries (one, two) {
    let result = []
    if (one) {
      result.push(one.name)
    }
    if (two) {
      result.push(two.name)
    }
    if (result.length === 0) {
      return false
    }
    return result.join(', ')
  },
  averageSGD (contributions) {
    let total = this.totalGivingSGD(contributions)
    if (total === 0) {
      return 0
    }
    let avgSGD = total / this.noOfGiving(contributions)
    return avgSGD.toFixed(2)
  },
  averageUSD (contributions) {
    let total = this.totalGivingUSD(contributions)
    if (total === 0) {
      return 0
    }
    let avgUSD = total / this.noOfGiving(contributions)
    return avgUSD.toFixed(2)
  },
  getMembershipEndDate (memberships) {
    if (memberships === null) {
      return false
    }
    if (!Array.isArray(memberships) || memberships.length === 0) {
      return false
    }
    return memberships[0].membership_end_date
  },
  getMembershipPaymentType (membership) {
    /* if(membership.no_of_installments === 1) {
     return 'One-time'
     }
     if(membership.no_of_installments > 1) {
     return 'Instalment';
     } */
    if (membership.membership_period_id === 1) {
      return 'Monthly'
    }
    if (membership.membership_period_id === '2' || membership.membership_period_id === '3' || membership.membership_period_id === '4') {
      return 'Annual'
    }
  },
  companyProfileComplete (company) {
    let percentage = 50
    if (company.company_logo !== null) {
      percentage = percentage + 10
    }
    if (company.mission !== null) {
      percentage = percentage + 10
    }
    if (company.email !== null) {
      percentage = percentage + 5
    }
    if (company.phone !== null) {
      percentage = percentage + 5
    }
    if (company.facebook_url !== null) {
      percentage = percentage + 4
    }
    if (company.googleplus_url !== null) {
      percentage = percentage + 4
    }
    if (company.linkedin_url !== null) {
      percentage = percentage + 4
    }
    if (company.twitter_url !== null) {
      percentage = percentage + 4
    }
    if (company.website !== null) {
      percentage = percentage + 4
    }
    return percentage
  },
  userBusinessProfileComplete (user, userBusiness) {
    let percentage = 50
    if (user.image && user.image.indexOf('no_image_user.png') === -1) {
      percentage = percentage + 10
    }
    if (user.first_name) {
      percentage = percentage + 10
    }
    if (userBusiness.about_you) {
      percentage = percentage + 10
    }
    if (userBusiness.facebook_url) {
      percentage = percentage + 5
    }
    if (userBusiness.googleplus_url) {
      percentage = percentage + 5
    }
    if (userBusiness.linkedin_url) {
      percentage = percentage + 5
    }
    if (userBusiness.twitter_url) {
      percentage = percentage + 5
    }
    return percentage
  },
  userPartnerProfileComplete (userPartner) {
    let percentage = 40
    if (userPartner.bank_account_name !== null) {
      percentage += 6
    }
    if (userPartner.account_number !== null) {
      percentage += 6
    }
    if (userPartner.bank_name !== null) {
      percentage += 6
    }
    if (userPartner.bank_address !== null) {
      percentage += 6
    }
    if (userPartner.finance_year_start !== null) {
      percentage += 6
    }
    if (userPartner.org_aboutus !== null) {
      percentage += 10
    }
    if (userPartner.org_mission !== null) {
      percentage += 10
    }
    if (userPartner.org_image !== null) {
      percentage += 10
    }
    return percentage
  },
  formatAddress (userBusiness) {
    let partsOfAddress = []
    if (userBusiness.address_1 !== null) {
      partsOfAddress.push(userBusiness.address_1)
    }
    if (userBusiness.address_2 !== null) {
      partsOfAddress.push(userBusiness.address_2)
    }
    if (userBusiness.city !== null) {
      partsOfAddress.push(userBusiness.city)
    }
    if (userBusiness.state !== null) {
      partsOfAddress.push(userBusiness.state)
    }
    if (userBusiness.country_name !== null) {
      partsOfAddress.push(userBusiness.country_name)
    }
    if (userBusiness.zip_code !== null) {
      partsOfAddress.push(userBusiness.zip_code)
    }
    if (partsOfAddress.length === 0) {
      return false
    }
    return partsOfAddress.join(', ')
  },

  /**
   * calc unused credit for company or user
   *
   * @param credits
   * @returns {number}
   */
  unusedCredits (credits) {
    if (!credits) {
      return 0
    }
    let creditAmount = 0
    let redeemedAmount = 0
    credits.forEach((credit) => {
      if (moment(credit.expiry_date) >= moment() || credit.expiry_date === '0000-00-00 00:00:00') {
        creditAmount += credit.credit_usd
        redeemedAmount += credit.amount_redeemed_usd
      }
    })
    return creditAmount - redeemedAmount
  },
  totalGivingUSD (contributions) {
    if (!contributions || (Array.isArray(contributions) && contributions.length === 0)) {
      return 0
    }
    let total = 0
    contributions.forEach((contribution) => {
      if (contribution.payment_received === 1) {
        total += contribution.amt_total_usd
      }
    })
    return total.toFixed(2)
  },
  totalGivingSGD (contributions) {
    if (!contributions || (Array.isArray(contributions) && contributions.length === 0)) {
      return 0
    }
    let total = 0
    // console.log(contributions.length)
    contributions.forEach((contribution) => {
      if (contribution.payment_received === 1) {
        total += contribution.amt_total_sgd
      }
    })
    return total.toFixed(2)
  },
  totalImpacts (contributions) {
    if (!contributions || (Array.isArray(contributions) && contributions.length === 0)) {
      return 0
    }
    let total = 0
    contributions.forEach((contribution) => {
      if (contribution.payment_received === 1) {
        total += contribution.beneficiaries
      }
    })
    return total
  },
  totalGiving (contributions) {
    if (!contributions || (Array.isArray(contributions) && contributions.length === 0)) {
      return 0
    }
    let total = []
    contributions.forEach((contribution) => {
      if (contribution.payment_received === 1) {
        // if (total.indexOf(contribution.contribution_group_id) === -1) {
        total.push(contribution.contribution_group_id)
        // }
      }
    })
    return total.length
  },
  noOfGiving (contributions) {
    if (!contributions || (Array.isArray(contributions) && contributions.length === 0)) {
      return 0
    }
    let total = []
    contributions.forEach((contribution) => {
      if (contribution.payment_received === 1) {
        if (total.indexOf(contribution.contribution_group_id) === -1) {
          total.push(contribution.contribution_group_id)
        }
      }
    })
    return total.length
  },
  getFirstGiving (contributions) {
    if (!contributions || (Array.isArray(contributions) && contributions.length === 0)) {
      return null
    }
    return contributions[0]
  },
  getLastGiving (contributions) {
    if (!contributions || (Array.isArray(contributions) && contributions.length === 0)) {
      return null
    }
    return contributions[contributions.length - 1]
  },
  getLastestGivingSGD (contributions) {
    // Calculate latest SGD amount of all records based on contribution group id
    if (!contributions || (Array.isArray(contributions) && contributions.length === 0)) {
      return 0
    }
    let lastestContributionId = contributions[contributions.length - 1].contribution_group_id
    let total = 0
    contributions.forEach((contribution) => {
      if (contribution.payment_received === 1 && contribution.contribution_group_id === lastestContributionId) {
        total += contribution.amt_total_sgd
      }
    })
    return total
  },
  getLastestGivingUSD (contributions) {
    // Calculate latest usd amount of all records based on contribution group id
    if (!contributions || (Array.isArray(contributions) && contributions.length === 0)) {
      return 0
    }
    let lastestContributionId = contributions[contributions.length - 1].contribution_group_id
    let total = 0
    contributions.forEach((contribution) => {
      if (contribution.payment_received === 1 && contribution.contribution_group_id === lastestContributionId) {
        total += contribution.amt_total_usd
      }
    })
    return total
  },
  getFavCategories (contributions) {
    if (!contributions || (Array.isArray(contributions) && contributions.length === 0)) {
      return null
    }
    let total = []
    contributions.forEach((contribution) => {
      if (contribution.payment_received === 1) {
        contribution.project_categories.forEach((category) => {
          let index = total.findIndex((el) => {
            return el.id === category.id
          })
          if (index === -1) {
            total.push({id: category.id, name: category.name, count: 1})
          } else {
            total[index].count += 1
          }
        })
      }
    })
    total.sort((first, last) => {
      return first.count - last.count
    })
    return total[total.length - 1].name
  },
  paidContributions (contributions) {
    if (!contributions || (Array.isArray(contributions) && contributions.length === 0)) {
      return contributions
    }
    let paidContributions = []
    contributions.forEach((contribution) => {
      if (contribution.payment_received === 1) {
        paidContributions.push(contribution)
      }
    })
    return paidContributions
  }
}



// WEBPACK FOOTER //
// ./src/helper/user.js